// @flow
import * as React from 'react';
import styled, {
  createGlobalStyle,
  /* $FlowFixMe */
  type ReactComponentStyled,
} from 'styled-components';
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuLink,
  MenuList,
} from '@reach/menu-button';
import '@reach/menu-button/styles.css';
import theme from './theme';
import { bodyStyles } from '../../internal/internal-typography';
import { TertiaryBody } from '../../typography';
import EllipsisIcon from '../../icons/ellipsis';

const MenuDivider: ReactComponentStyled<{}> = styled.div`
  margin: 8px 0;
  border-top: 1px solid ${theme.default.borderColor};
`;

const StyledMenuList: ReactComponentStyled<{}> = styled(MenuList).attrs({
  'data-provides': 'menu-list',
})`
  &[data-reach-menu-items] {
    box-sizing: border-box;
    padding: 0;
    width: 312px;
    border: 1px solid ${theme.default.borderColor};
    border-radius: 5px;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.13);
  }
`;
StyledMenuList.displayName = 'MenuList';

const StyledMenuButton: ReactComponentStyled<{}> = styled(MenuButton).attrs({
  'data-provides': 'menu-button',
})``;

const TransparentMenuButton: ReactComponentStyled<{}> = styled(
  StyledMenuButton
)`
  background-color: ${theme.default.emptyButtonBackgroundColor};
  border: none;
`;

const StyledMenuItem: ReactComponentStyled<{}> = styled(MenuItem).attrs({
  'data-provides': 'menu-item',
})``;
StyledMenuItem.displayName = 'MenuItem';

const MenuHeader: ReactComponentStyled<{ medium?: boolean }> = styled.div.attrs(
  {
    'data-provides': 'menu-header',
  }
)`
  ${bodyStyles};
  padding: 16px;
  white-space: normal;
  color: ${theme.default.headerColor};
`;
MenuHeader.displayName = 'MenuHeader';
MenuHeader.defaultProps = {
  medium: true,
};

type MenuItemDescriptionProps = {};
const MenuItemDescription = (props: MenuItemDescriptionProps) => {
  return <TertiaryBody {...props} />;
};
MenuItemDescription.displayName = 'MenuItemDescription';

const EllipsisMenuButton = () => {
  return (
    <TransparentMenuButton>
      <EllipsisIcon />
    </TransparentMenuButton>
  );
};

const MenuTheme = createGlobalStyle`
  [data-reach-menu-item][data-reach-menu-item] {
    ${bodyStyles};
    padding: 16px;
    white-space: normal;
    background-color: ${theme.default.listItemBackgroundColor};

    &[data-selected] {
      color: ${theme.default.textColor};
      background-color: ${theme.hover.listItemBackgroundColor};
    }

    a&[data-selected] {
      color: ${theme.default.linkHover};
      background-color: ${theme.hover.listItemBackgroundColor};
    }
  }
`;

type ExpandableMenuProps = {
  children: React.Node,
};
const ExpandableMenu = (props: ExpandableMenuProps) => {
  return (
    <>
      <MenuTheme />
      <Menu {...props} />
    </>
  );
};

MenuLink.defaultProps = {
  'data-provides': 'menu-link',
};

export {
  ExpandableMenu,
  /* Deprecated, use TransparentMenuButton wrapping an EllipsisIcon */
  EllipsisMenuButton,
  StyledMenuButton as MenuButton,
  TransparentMenuButton,
  StyledMenuList as MenuList,
  StyledMenuItem as MenuItem,
  MenuLink,
  MenuHeader,
  MenuItemDescription,
  MenuDivider,
};
